import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var GroupIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M12 5.318a2.636 2.636 0 100 5.273 2.636 2.636 0 000-5.273zM7.364 7.954a4.636 4.636 0 119.272 0 4.636 4.636 0 01-9.272 0zm9.999-1.818a1 1 0 011-1 3.727 3.727 0 010 7.455 1 1 0 110-2 1.727 1.727 0 100-3.455 1 1 0 01-1-1zm-10.727 0a1 1 0 00-1-1 3.727 3.727 0 000 7.455 1 1 0 100-2 1.727 1.727 0 110-3.455 1 1 0 001-1zm3.909 9.182a3 3 0 00-3 3v2.364a1 1 0 01-2 0v-2.364a5 5 0 015-5h2.91a5 5 0 015 5v2.364a1 1 0 01-2 0v-2.364a3 3 0 00-3-3h-2.91zm7.273-1a1 1 0 011-1A4.182 4.182 0 0123 17.5v1.364a1 1 0 11-2 0V17.5a2.182 2.182 0 00-2.182-2.182 1 1 0 01-1-1zm-11.636 0a1 1 0 00-1-1A4.182 4.182 0 001 17.5v1.364a1 1 0 102 0V17.5c0-1.205.977-2.182 2.182-2.182a1 1 0 001-1z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
GroupIcon.isCarinaIcon = true;
export default GroupIcon;
